
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Button from '../../components/base/Button';
import { Link } from 'react-router-dom';

export default function Team() {
  const teamMembers = [
    {
      name: 'Kayode Ogunsua',
      position: 'Chief Executive Officer (CEO) & Managing Director',
      image: 'https://static.readdy.ai/image/ee7d0f3d5dd5d8644a11a0562535fbc0/f6ba345a5f6d24a92011fbcc726fa19b.jpeg',
      bio: `Mr. Kayode Ogunsua is the Chief Executive Officer of Olatunde International Limited, where he has played a pivotal role in the company's growth and transformation. Known for his visionary leadership, discipline, and deep industry insight, he has guided the company to become one of Nigeria's leading cocoa exporters.

His journey with the organization began in 1989 as an Assistant Store Manager. By 1991, he had advanced to Procurement and Marketing Officer, and in 1995, he was appointed Managing Director. His long-standing commitment to operational excellence and sustainable trade earned the title of Chief Executive Officer in 2021.

Under his leadership, Olatunde International Limited has built a sustainable, traceable cocoa supply chain, directly engaging over 20,000 farmers and consistently delivering high-quality Nigerian cocoa to global markets.`,
      achievements: [
        'Led company transformation since 1989',
        'Built sustainable supply chain engaging 20,000+ farmers',
        'Achieved industry-leading quality standards',
        'Pioneered ethical sourcing practices'
      ]
    },
    {
      name: 'Adekola Ogunsua',
      position: 'Executive Director, Business Operations & Supply Chain',
      image: 'https://static.readdy.ai/image/ee7d0f3d5dd5d8644a11a0562535fbc0/3783a6bdb17eb8a4c689c33f13709c0e.jpeg',
      bio: `Mr. Adekola Ogunsua is the Executive Director and Chief Business Operations & Supply Chain Officer at Olatunde International Limited. With over 23 years of leadership experience, he is a respected expert in sustainable cocoa supply chains, agribusiness development, and financial management.

Mr. Ogunsua is widely recognized for his strategic oversight, operational excellence, and people-centered leadership. He has successfully led the development of traceable, ethically responsible sourcing systems that have positively impacted the livelihoods of thousands of farmers. His initiatives have also driven multi-stakeholder collaborations that promote transparency, sustainability, and resilience across the cocoa value chain.

His journey with Olatunde began in 1995 as Operations Manager, where he played a key role in expanding and optimizing field operations. In 2021, his outstanding contributions earned him the role of Chief Business Operations & Supply Chain Officer.`,
      achievements: [
        '23+ years of leadership experience',
        'Expert in sustainable supply chain development',
        'Champion of farmer livelihood programs',
        'Leader in multi-stakeholder collaborations'
      ]
    },
    {
      name: 'Olusegun Amoje',
      position: 'Chief Financial Officer (CFO)',
      image: 'https://static.readdy.ai/image/ee7d0f3d5dd5d8644a11a0562535fbc0/1d30e909b23dcb7f1d993509f4a1f627.png',
      bio: `Mr. Olusegun Amoje is a seasoned Accountant and the Chief Financial Officer (CFO) of Olatunde International Limited, appointed to the role in 2021. With over 35 years of experience in accounting, financial management, and corporate governance, he plays a pivotal role in shaping the company's financial strategy and ensuring long-term sustainability.

Mr. Amoje joined Olatunde International Limited in 2003 as Finance and Administrative Manager, following a distinguished career in accounting education and professional practice. His leadership and analytical skills led to his appointment as Head of Economic Analysis and Finance Management in 2010, and later as Head of Internal Audit and Accounting in 2015.

As CFO, he oversees all aspects of financial planning, budgeting, compliance, and reporting ensuring financial integrity, operational efficiency, and alignment with the company's strategic vision.`,
      achievements: [
        '35+ years in accounting and financial management',
        'Seasoned Accountant with distinguished career',
        'Expert in corporate governance and compliance',
        'Strategic financial planning and risk management'
      ]
    },
    {
      name: 'Johnson Olubunmi Samuel',
      position: 'Head of Financial Reporting and Control',
      image: 'https://static.readdy.ai/image/ee7d0f3d5dd5d8644a11a0562535fbc0/198cf752500693ecb95eb5cd2a7cb950.jpeg',
      bio: `Johnson Olubunmi Samuel (B.Sc, FCA) is a seasoned Finance, Audit, and Risk Management professional with over 12 years of progressive experience spanning financial reporting, internal controls, budgeting, treasury, and corporate governance across multinational and indigenous organizations. He currently serves as the Head of Financial Reporting and Control at Olatunde International Limited, a foremost Nigerian export company, where he drives group-wide financial strategy, reporting excellence, and internal control compliance.

Johnson has demonstrated expertise in IFRS-compliant reporting, audit coordination, controls implementation, financial modelling, and enterprise risk management. He has a proven track record of strengthening financial processes, optimizing reporting efficiency, and ensuring regulatory compliance. His career includes key roles in healthcare, consulting, and multinational manufacturing environments, notably Michelin Tyre Services Nigeria, where he excelled in treasury operations, subsidiary financial management, budgeting, and internal audit.

A Fellow of the Institute of Chartered Accountants of Nigeria (ICAN) and a member of Financial Reporting Council of Nigeria (FRCN), Johnson combines strong technical capability with strategic leadership, process improvement mindset, and exceptional analytical skills. He has led the development of Standard Operating Procedures (SOPs), championed ISO-compliant quality and risk initiatives, and supported cross-functional teams in achieving operational and financial discipline.`,
      achievements: [
        'Fellow of the Institute of Chartered Accountants of Nigeria (ICAN)',
        '12+ years in finance, audit, and risk management',
        'Expert in IFRS-compliant reporting and financial modelling',
        'Proven track record in multinational environments including Michelin'
      ]
    },
    {
      name: 'Bamidele Asoberedowo',
      position: 'Chief, Warehousing & Export Operations',
      image: 'https://static.readdy.ai/image/ee7d0f3d5dd5d8644a11a0562535fbc0/23399da96d27e7a805ccbafaa674c552.jpeg',
      bio: `Mr. Bamidele Asoberedowo is the Chief of Warehousing and Export Operations at Olatunde International Limited, appointed to the role in 2022. As a Certified Agricultural Extension Work Manager, he has over 17 years of hands‑on experience in cocoa logistics, warehousing, and quality assurance.

Mr. Asoberedowo began his journey with the company in 2008 as a Warehouse Officer. His dedication and attention to details earned several promotions, including Assistant Quality Assurance Manager (2010), Quality Assurance Manager (2013), Export and Forwarding Officer (2015), and Assistant Director of Export Operations (2018). In these roles, he was instrumental in strengthening the company's export compliance systems and enhancing logistics efficiency.

In his current role, Mr. Asoberedowo oversees the coordination of warehousing activities, export documentation, container stuffing, and regulatory inspections, ensuring that all cocoa shipments meet global quality and compliance standards.`,
      achievements: [
        '17+ years in cocoa logistics and warehousing',
        'Certified Agricultural Extension Work Manager',
        'Expert in export compliance and quality assurance',
        'Leader in logistics efficiency optimization'
      ]
    },
    {
      name: 'Omoniyi Idowu',
      position: 'Chief, Procurement, Vendor & Marketing',
      image: 'https://static.readdy.ai/image/ee7d0f3d5dd5d8644a11a0562535fbc0/2527da740f4e14f5e0fe2845c64829b7.jpeg',
      bio: `Mr. Omoniyi Idowu is the Chief Procurement, Vendor, and Marketing Officer at Olatunde International Limited, appointed to the role in 2022. With over 20 years of experience in the cocoa supply chain, he brings a unique blend of expertise in banking, finance, and logistics to his leadership of the company's procurement and commercial operations.

Mr. Idowu began his career at Olatunde International Limited in 2007 as Assistant Haulage Manager, progressing through key roles including Haulage Manager (2010), Procurement Officer (2015), and Marketing Manager for the South West Zone (2019). His in‑depth knowledge of market dynamics, vendor engagement, and procurement strategy has been pivotal in expanding and strengthening the company's sourcing networks.

Recognized for his commitment, analytical acumen, and leadership, Mr. Idowu continues to drive innovation in procurement processes and vendor relationships, ensuring optimal sourcing strategies that support the company's growth and sustainability objectives.`,
      achievements: [
        '20+ years in cocoa supply chain management',
        'Expert in banking, finance, and logistics',
        'Leader in vendor engagement and procurement strategy',
        'Champion of sourcing network expansion'
      ]
    },
    {
      name: 'Yemi Ademola',
      position: 'Head of Haulage & Logistics',
      image: 'https://static.readdy.ai/image/ee7d0f3d5dd5d8644a11a0562535fbc0/40721eef07437e63477da51faa350e72.jpeg',
      bio: `Mrs. Yemi Ademola is the Head of Haulage and Logistics at Olatunde International Limited, appointed to the role in 2022. With over 20 years of experience in logistics management, she brings exceptional technical expertise and regulatory knowledge to the company's transport operations. She is a Certified Integrated Pest Management (IPM) Specialist and a trained RA 2020 Farm Compliance Officer.

Mrs. Ademola began her journey with the company in 2004 as an Office Assistant and rose steadily through the ranks, becoming a Clerical Officer in 2006, Haulage Officer in 2010, and Fuel Depot Manager in 2015. In 2019, she was promoted to Assistant Haulage and Logistics Manager, where she played a key role in fleet coordination, fuel oversight, and logistical efficiency.

Today, she leads Olatunde's logistics and haulage operations, ensuring the timely, safe, and compliant movement of cocoa across the supply chain, from sourcing zones to export hubs.`,
      achievements: [
        '20+ years in logistics management',
        'Certified IPM Specialist and RA 2020 Farm Compliance Officer',
        'Expert in fleet coordination and fuel management',
        'Leader in supply chain logistics optimization'
      ]
    },
    {
      name: 'Adebayo Damilola',
      position: 'Sustainability Manager',
      image: 'https://static.readdy.ai/image/ee7d0f3d5dd5d8644a11a0562535fbc0/cf67ffd2734bc29c9e8e5e12867ea8a9.jpeg',
      bio: `Mr. Adebayo Damilola joined Olatunde International Limited in 2017 and has since demonstrated remarkable versatility and dedication in advancing the company's growth and sustainability agenda. He began his career as a GAP Trainer in the Certification Department, where he supported farmer training and compliance initiatives. In 2018, he transitioned to Akure as a Data Analyst, contributing significantly to the registration and certification of more than 5,000 cocoa farmers, thereby strengthening supply chain traceability and sustainability.

Upon returning to Akure, he briefly worked in the Export Department before moving into the Agrochemicals Division, where he rose to Production & Sales Manager. In this role, he managed cocoa fungicide operations and achieved a major milestone in 2020 by successfully leading the NAFDAC registration of Zyprone Fungicide, broadening the company's product portfolio.

Today, Damilola leads Olatunde's sustainability programs, championing ethical trade, farmer empowerment, and environmental stewardship. His career embodies leadership, innovation, and a strong commitment to building a responsible cocoa industry.`,
      achievements: [
        'Certified and registered 5,000+ cocoa farmers',
        'Successfully led NAFDAC registration of Zyprone Fungicide',
        'Expert in GAP training and farmer compliance',
        'Champion of ethical trade and environmental stewardship'
      ]
    },
    {
      name: 'Success Opeyemi',
      position: 'Internal Control Officer',
      image: 'https://static.readdy.ai/image/ee7d0f3d5dd5d8644a11a0562535fbc0/4f3cb07a434e0ea133d5e7aa76fd36e8.jpeg',
      bio: `Mr. Success Opeyemi is a dedicated and results-driven professional with a strong background in business administration, accounting, and financial management. He graduated from The Federal Polytechnic, Ede, Osun State, as the Overall Best Student in the 2006/2007 academic session, earning a Distinction in Business Administration and Management. His outstanding academic performance reflects his commitment to excellence and analytical rigor.

He is an Associate Accounting Technician (AAT) certified by the Institute of Chartered Accountants of Nigeria (ICAN), demonstrating his proficiency in core accounting principles, financial reporting, and ethical standards in the profession.

Success has gained valuable experience in financial operations, internal auditing, and compliance. During his tenure at Coop Mortgage and Loans Limited, Ibadan, he was actively involved in internal audit functions, financial control, and regulatory compliance, where he contributed to strengthening internal processes and ensuring adherence to financial policies.

In 2013, he joined Olatunde International Limited as an Internal Control Officer, where he continues to apply his expertise in risk assessment, process improvement, and governance to enhance organizational efficiency and accountability. His career reflects a blend of academic excellence, professional discipline, and practical experience in driving transparency and financial integrity within corporate environments.`,
      achievements: [
        'Overall Best Student with Distinction in Business Administration',
        'Associate Accounting Technician (AAT) certified by ICAN',
        'Expert in internal auditing and regulatory compliance',
        'Specialist in risk assessment and process improvement'
      ]
    }
  ];

  const departments = [
    {
      name: 'Quality Assurance',
      icon: 'ri-award-line',
      description: 'Ensuring every batch meets international standards'
    },
    {
      name: 'Supply Chain',
      icon: 'ri-truck-line',
      description: 'Managing traceable sourcing from farm to port'
    },
    {
      name: 'Farmer Relations',
      icon: 'ri-group-line',
      description: 'Building partnerships with farming communities'
    },
    {
      name: 'Sustainability',
      icon: 'ri-leaf-line',
      description: 'Driving environmental and social responsibility'
    },
    {
      name: 'Export Operations',
      icon: 'ri-ship-line',
      description: 'Managing global logistics and compliance'
    },
    {
      name: 'Finance & Administration',
      icon: 'ri-calculator-line',
      description: 'Supporting business operations and growth'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section 
        className="relative py-32"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url('https://readdy.ai/api/search-image?query=Professional%20Nigerian%20corporate%20boardroom%20meeting%20with%20executives%20seated%20around%20large%20conference%20table%2C%20Nigerian%20flag%20prominently%20displayed%20in%20background%20with%20green%20white%20green%20colors%2C%20formal%20business%20setting%20with%20modern%20office%20interior%2C%20diverse%20group%20of%20African%20business%20leaders%20in%20suits%2C%20warm%20professional%20lighting%2C%20executive%20board%20meeting%20atmosphere%20with%20Nigerian%20green%20white%20green%20flag%20elements%20and%20corporate%20governance%20setup%2C%20no%20yellow%20or%20red%20colors&width=1920&height=800&seq=boardroom-nigeria-green-white&orientation=landscape')`
        }}
      >
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
            Meet Our Team
          </h1>
          <p className="text-xl md:text-2xl text-gray-200 max-w-4xl mx-auto leading-relaxed">
            Dedicated professionals driving excellence in Nigerian cocoa export through 
            decades of expertise, sustainable practices, and unwavering commitment to quality.
          </p>
        </div>
      </section>

      {/* Leadership Team */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-green-800 mb-4">Leadership Team</h2>
            <p className="text-xl text-gray-600">Visionary leaders with decades of industry experience</p>
          </div>

          <div className="space-y-20">
            {teamMembers.map((member, index) => (
              <div key={index} className={`grid grid-cols-1 lg:grid-cols-2 gap-16 items-center ${index % 2 === 1 ? 'lg:grid-flow-col-dense' : ''}`}>
                <div className={index % 2 === 1 ? 'lg:col-start-2' : ''}>
                  <div className="relative">
                    <img 
                      src={member.image}
                      alt={member.name}
                      className="w-full max-w-md mx-auto rounded-2xl shadow-2xl object-cover object-top"
                      style={{ aspectRatio: '4/5' }}
                    />
                    <div className="absolute -bottom-6 -right-6 w-24 h-24 bg-amber-600 rounded-full flex items-center justify-center shadow-lg">
                      <i className="ri-user-star-line text-2xl text-white"></i>
                    </div>
                  </div>
                </div>
                
                <div className={index % 2 === 1 ? 'lg:col-start-1 lg:row-start-1' : ''}>
                  <div className="bg-gradient-to-br from-green-50 to-green-100 p-8 rounded-2xl">
                    <h3 className="text-3xl font-bold text-green-800 mb-2">{member.name}</h3>
                    <p className="text-xl text-amber-600 font-semibold mb-6">{member.position}</p>
                    
                    <div className="space-y-4 text-gray-700 leading-relaxed mb-8">
                      {member.bio.split('\n\n').map((paragraph, pIndex) => (
                        <p key={pIndex}>{paragraph}</p>
                      ))}
                    </div>

                    <div>
                      <h4 className="text-lg font-semibold text-green-800 mb-4">Key Achievements</h4>
                      <ul className="space-y-2">
                        {member.achievements.map((achievement, aIndex) => (
                          <li key={aIndex} className="flex items-start space-x-3">
                            <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                              <i className="ri-check-line text-green-600"></i>
                            </div>
                            <span className="text-gray-700">{achievement}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Team Statistics */}
      <section className="py-20 bg-green-700">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-white mb-4">Our Team Impact</h2>
            <p className="text-xl text-green-100">Delivering results through experienced leadership</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="text-5xl font-bold text-amber-400 mb-2">35+</div>
              <p className="text-green-100 text-lg">Combined Years of Leadership</p>
            </div>
            <div className="text-center">
              <div className="text-5xl font-bold text-amber-400 mb-2">25,000+</div>
              <p className="text-green-100 text-lg">Farmers Engaged</p>
            </div>
            <div className="text-center">
              <div className="text-5xl font-bold text-amber-400 mb-2">100,000+</div>
              <p className="text-green-100 text-lg">MT Annual Capacity</p>
            </div>
            <div className="text-center">
              <div className="text-5xl font-bold text-amber-400 mb-2">15+</div>
              <p className="text-green-100 text-lg">International Markets</p>
            </div>
          </div>
        </div>
      </section>

      {/* Departments */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-green-800 mb-4">Our Departments</h2>
            <p className="text-xl text-gray-600">Specialized teams working together for excellence</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {departments.map((dept, index) => (
              <div key={index} className="bg-white p-8 rounded-xl shadow-lg hover:shadow-xl transition-shadow">
                <div className="w-16 h-16 bg-gradient-to-br from-green-500 to-green-600 rounded-full flex items-center justify-center mb-6">
                  <i className={`${dept.icon} text-2xl text-white`}></i>
                </div>
                <h3 className="text-xl font-bold text-green-800 mb-4">{dept.name}</h3>
                <p className="text-gray-600 leading-relaxed">{dept.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Company Culture */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div>
              <h2 className="text-4xl font-bold text-green-800 mb-6">Our Company Culture</h2>
              <div className="space-y-6 text-lg text-gray-700 leading-relaxed">
                <p>
                  At Olatunde International Limited, our culture is built on integrity, sustainability, 
                  and a deep commitment to empowering farming communities. We believe that our success 
                  is directly tied to the prosperity of the farmers we work with.
                </p>
                <p>
                  Our team operates with transparency, accountability, and a shared vision of creating 
                  a more sustainable cocoa industry. We foster an environment where innovation thrives, 
                  relationships matter, and every team member contributes to our mission of delivering 
                  excellence in Nigerian cocoa export.
                </p>
                <p>
                  From our leadership team to field operations, we maintain the highest standards of 
                  professionalism while staying true to our core values of respect, collaboration, 
                  and continuous improvement.
                </p>
              </div>
            </div>
            
            <div className="grid grid-cols-2 gap-6">
              <div className="bg-green-100 p-6 rounded-xl text-center">
                <div className="w-12 h-12 bg-green-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-heart-line text-white text-xl"></i>
                </div>
                <h3 className="text-lg font-semibold text-green-800 mb-2">Integrity</h3>
                <p className="text-gray-600 text-sm">Honest, transparent business practices</p>
              </div>
              
              <div className="bg-amber-100 p-6 rounded-xl text-center">
                <div className="w-12 h-12 bg-amber-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-leaf-line text-white text-xl"></i>
                </div>
                <h3 className="text-lg font-semibold text-amber-800 mb-2">Sustainability</h3>
                <p className="text-gray-600 text-sm">Environmental responsibility</p>
              </div>
              
              <div className="bg-green-100 p-6 rounded-xl text-center">
                <div className="w-12 h-12 bg-green-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-team-line text-white text-xl"></i>
                </div>
                <h3 className="text-lg font-semibold text-green-800 mb-2">Collaboration</h3>
                <p className="text-gray-600 text-sm">Working together for success</p>
              </div>
              
              <div className="bg-amber-100 p-6 rounded-xl text-center">
                <div className="w-12 h-12 bg-amber-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-trophy-line text-white text-xl"></i>
                </div>
                <h3 className="text-lg font-semibold text-amber-800 mb-2">Excellence</h3>
                <p className="text-gray-600 text-sm">Continuous improvement</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-r from-green-700 to-green-800">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-4xl font-bold text-white mb-6">
            Join Our Mission
          </h2>
          <p className="text-xl text-green-100 mb-8 max-w-3xl mx-auto">
            Work with a team that's passionate about sustainable cocoa trade and 
            making a positive impact on farming communities across Nigeria.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <Link to="/about">
              <Button variant="primary" size="lg" className="bg-amber-600 hover:bg-amber-700 whitespace-nowrap">
                Learn About Us
              </Button>
            </Link>
            <Button variant="outline" size="lg" className="border-white text-white hover:bg-white hover:text-green-800 whitespace-nowrap">
              Contact Our Team
            </Button>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
